import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { TouchApp } from '@mui/icons-material';

export const StyledMobileHint = styled(Box)(() => ({
  display: 'block',
  marginTop: 8,
  fontStyle: 'italic'
}));

export const StyledTouchIcon = styled(TouchApp)(() => ({
  fontSize: '1rem',
  verticalAlign: 'middle',
  marginRight: 4
}));
